export default __webpack_public_path__ + "static/default-e1b72e1e5b2cf5b3dcb21d6be5ef9159.jpeg";